import { Circle, PlayArrow } from "@mui/icons-material";
import { Box, Divider, Typography } from "@mui/material";
import { Observer } from "mobx-react-lite";
import { Edge, Handle, Node, NodeProps, Position, useReactFlow } from "reactflow";
import { EdgeData } from "../../../app/models/edgeData";
import { GraphNodeData } from "../../../app/models/graphData";
import { useStore } from "../../../app/stores/store";
import { NodeLabelIconData } from "../../nodes/NodeCardLabelIcon";
import "./CustomNode.css";

enum NodeState {
  Primary,
  Secondary,
  Disable,
}

export default function CustomNode({
  id,
  data,
  isConnectable,
}: NodeProps<GraphNodeData>) {
  const { graphStore } = useStore();
  const reactflow = useReactFlow();

  const background = NodeLabelIconData[data.type];

  return (
    <Observer>
      {() => {
        const nodeState = getNodeState(
          id,
          reactflow.getEdges(),
          graphStore.selectedNode,
          graphStore.selectedEdge
        );

        return (
          <div
            className={"custom-node__root"}
            style={{
              ...(nodeState === NodeState.Primary
                ? {
                  color: "#FFFFFF",
                  background: background.primary,
                }
                : nodeState === NodeState.Secondary
                  ? {
                    color: "#141218",
                    background: background.secondary,
                  }
                  : {
                    border: "1px solid #141218",
                    opacity: "0.2",
                  }),
            }}
          >
            <Handle
              type="target"
              position={Position.Top}
              isConnectable={isConnectable}
            >
              <PlayArrow className="custom-node__play-arrow out" />
              <PlayArrow className="custom-node__play-arrow in" />
            </Handle>

            <Typography fontWeight={700}>{data.title}</Typography>

            <Box
              hidden={!graphStore.showId}
              className="custom-node-additional-details"
            >
              <Divider sx={{ margin: 0 }} />

              <Typography variant="caption" fontSize={6}>
                {id}
              </Typography>
            </Box>

            <Handle
              type="source"
              position={Position.Bottom}
              isConnectable={isConnectable}
            >
              <Circle className="custom-node__circle out" />
              <Circle className="custom-node__circle in" />
            </Handle>
          </div>
        );
      }}
    </Observer>
  );
}

function getNodeState(
  nodeId: string,
  edges: Edge[],
  selectedNode: Node<GraphNodeData> | null,
  selectedEdge: Edge<EdgeData> | null
): NodeState {
  if (!!!selectedNode) {
    if (!!!selectedEdge) {
      return NodeState.Secondary;
    }

    return selectedEdge.source === nodeId || selectedEdge.target === nodeId
      ? NodeState.Primary
      : NodeState.Disable;
  }

  if (selectedNode.id === nodeId) return NodeState.Primary;

  if (
    edges.find(
      (edge) =>
        (nodeId === edge.target && selectedNode.id === edge.source) ||
        (nodeId === edge.source && selectedNode.id === edge.target)
    )
  )
    return NodeState.Secondary;

  return NodeState.Disable;
}
